<div class="page-container">
  <div class="page-container__header">
    <app-page-header
      [title]="title()"
      [subtitle]="subtitle()"
      [icon]="icon()"
      [actions]="actions()"
      (actionClick)="action.emit($event)"
    />
  </div>
  <div class="page-container__content">
    <ng-content />
  </div>
</div>
